module.exports = __webpack_public_path__ + "static/media/ins-ld-bg-mobile.b388202b.png";